/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */

import { Cookies } from 'react-cookie';
import { Logger } from '@saviynt/common';
import axios from 'axios';

import { getBaseURL } from './utils';

export const TIMEOUT_CANCELLATION = 'ECONNABORTED';
export const AXIOS_TIMEOUT_ERROR_MESSAGE =
  'There is some problem due to a network issue. Please try again later';

const cookies = new Cookies();

// Create the Axios instance
const httpService = axios.create({
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor for adding the bearer token dynamically
httpService.interceptors.request.use(
  (config) => {
    config.baseURL = getBaseURL(config.url);
    // Token is added from cookies dynamically for each request
    const token = cookies.get('access_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
httpService.interceptors.response.use(
  (response) => {
    const { responseURL } = response.request;

    if (responseURL) {
      try {
        // Info: Redirecting to login page, when session expires
        if (responseURL.includes('/login/auth')) {
          window.location.reload();
        }
      } catch (e) {
        Logger.log('redirecting error');
      }
    }

    return response;
  }, // Simply return the response if it's successful
  (error) => {
    // If the error status is 401, refresh the page
    if (error.response && error.response.status === 401) {
      // reload the page
      window.location.reload();
    }

    if (error.response && error.response.status === 403) {
      return Promise.reject(error.response.status);
    }

    if (
      (axios.isAxiosError(error) && error.response) || // Axios error with response
      error?.code === TIMEOUT_CANCELLATION // Timeout error
    ) {
      return Promise.reject(AXIOS_TIMEOUT_ERROR_MESSAGE);
    }

    return Promise.reject(error);
  }
);

// Export the API instance
export { httpService };
